import cx from 'classnames';
import PropTypes from 'prop-types';

import { detectedBrandTermHasReplacement } from 'src/data/brandTerm';

import { ReplacementTerms } from './components/ReplacementTerms';
import { TermHeader } from './components/TermHeader';
import { useStyles } from './useStyles';

export const DetectedBrandTerm = ({
  className,
  classes,
  headerClasses,
  detectedBrandTerm,
  onApplyClick,
  onHover,
  onClick,
  hoverable,
  disabled,
  readOnly,
}) => {
  const styles = useStyles({ classes });

  const hasReplacements = detectedBrandTermHasReplacement(detectedBrandTerm);

  const handleApplyClick = (event) => {
    event.stopPropagation();
    onApplyClick(detectedBrandTerm);
  };

  const handleClick = () => {
    if (!onClick || disabled) {
      return;
    }
    onClick(detectedBrandTerm);
  };

  const handleMouseEnter = () => {
    if (!onHover || disabled) {
      return;
    }
    onHover(detectedBrandTerm);
  };

  const handleMouseLeave = () => {
    if (!onHover || disabled) {
      return;
    }
    onHover(null);
  };

  return (
    <div
      className={cx(styles.root, className, {
        [styles.hoverable]: hoverable,
        [styles.disabled]: disabled,
        [styles.hasReplacements]: hasReplacements && !readOnly,
      })}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
      data-id={detectedBrandTerm.id}
    >
      <TermHeader
        className={styles.header}
        classes={headerClasses}
        detectedBrandTerm={detectedBrandTerm}
        onApplyClick={hasReplacements && !readOnly ? handleApplyClick : null}
        disabled={disabled}
      />

      {hasReplacements && (
        <ReplacementTerms
          className={styles.replacementTerms}
          detectedBrandTerm={detectedBrandTerm}
        />
      )}
    </div>
  );
};

DetectedBrandTerm.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  headerClasses: PropTypes.shape({}),
  detectedBrandTerm: PropTypes.shape({
    id: PropTypes.string,
    brandTerm: PropTypes.shape(),
    termInText: PropTypes.string,
  }).isRequired,
  onApplyClick: PropTypes.func.isRequired,
  onHover: PropTypes.func,
  onClick: PropTypes.func,
  hoverable: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
};

DetectedBrandTerm.defaultProps = {
  className: '',
  classes: null,
  headerClasses: null,
  onHover: null,
  onClick: null,
  hoverable: false,
  disabled: false,
  readOnly: false,
};
